import {
  Icon as LeelooIcon,
  IconProps as LeelooIconProps
} from "@orgmym/leeloo-core";

export const Icon = (props: LeelooIconProps) => {
  return <LeelooIcon {...props} />;
};
